import { css } from "aphrodite";
import { CommonLayout } from "../../common/components/CommonLayout";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import appointmentCompletedIcon from "../../assets/icons/appointmentCompletedIcon.svg";
import { CommonLayoutTitle } from "../../common/components/CommonLayoutTitle";
import { CustomMainButton } from "../../common/components/CustomMainButton";
import { useNavigate } from "react-router";
import { RoutePath } from "../../../Utils/routePath";
import { useSelector } from "react-redux";
import { Appointment, Media } from "../../../Models";
import { Typography } from "@mui/material";
import { CompleteCommonMobileLayout } from "../../common/components/CompleteCommonMobileLayout";
import React, {useEffect, useState} from "react";
import i18n from "../../../i18n";
import { AccessibleLink } from "../../common/components/AccessibleLink";

const AppointmentCompletedPage = () => {
    const [t] = useTranslation(["translation"]);
    const navigate = useNavigate();
    const bookCode = useSelector(Appointment.getBookCode);
    const webView = useSelector(Media.getIsWebView);
    const selectedService = useSelector(Appointment.getSelectedService);
    const [link, setLink] = useState('')

    useEffect(() => {
        setLink( selectedService?.['description_' + i18n.language] || '')
    }, [selectedService?.['description_' + i18n.language]]);

    const handleGoHome = () => {
        navigate(RoutePath.appointmentPage);
    };

    return (
        <CommonLayout>
            {webView ?
            (
                <>
                    <CommonLayoutTitle
                        statusTitle={''}
                        iconSrc={appointmentCompletedIcon}
                        title={t("Your Appointment has been booked")}
                        description={t(
                            "The Reference Number to your appointment has been sent to the e-mail and/or phone that you provided. Please make sure you don't lose this number, in the event that you wish to edit or cancel your appointment."
                        )}
                        stepDataLayoutVisible={true}
                    />
                    <div className={css(styles.container)}>
                        <Typography variant="h5" component="h2">{t("Reference Number: ")}</Typography>
                        <Typography variant="h5" component="p">{bookCode || "-----"}</Typography>
                            {link && (
                                <div className={css(styles.descriptionContainer)}>
                                    <Typography variant="body1" style={{ marginTop: '16px' }}>
                                        {i18n.language === 'gr' 
                                            ? <>Δείτε περισσότερες λεπτομέρειες για το ραντεβού σας, πατώντας{' '}<strong><AccessibleLink href={link} external style={{ fontWeight: 'bold' }}>εδώ</AccessibleLink></strong>.</>
                                            : <>Click{' '}<strong><AccessibleLink href={link} external style={{ fontWeight: 'bold' }}>here</AccessibleLink></strong> to view more details about your appointment</>
                                        }
                                    </Typography>
                                </div>
                            )}                        
                        <CustomMainButton
                            color="primary"
                            style={styles.button}
                            value={t("Back to Home")}
                            onClick={handleGoHome}
                        />
                    </div>
                </>
            ) : (
                <CompleteCommonMobileLayout
                    title={''}
                    iconSrc={appointmentCompletedIcon}
                    subTitle={t("Your Appointment has been booked")}
                    description={t(
                        "The Reference Number to your appointment has been sent to the e-mail and/or phone that you provided. Please make sure you don't lose this number, in the event that you wish to edit or cancel your appointment."
                    )}
                    link={link}
                    appointmentValuesVisible={true}
                    referenceNumber={bookCode || "-----"}
                    handleGoHome={handleGoHome}
                />
            )}
        </CommonLayout>
    );
};

export default AppointmentCompletedPage;
